export default async ({ store, redirect }) => {
  if (store.state.global.loggedIn) {
    return redirect('/');
  }
};
